import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
    Box, Container, Radio, RadioGroup, Typography, Grid, 
    TextField, Button,
    InputLabel, Select, MenuItem, Snackbar, Alert 
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';



const Register = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        mobile: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
        identityProofType: "", // Stores either 'Aadhar' or 'License'
        identityProofNumber: "",
        panCard:" ",
        panCardNumber:  "",
    });
    const [errors, setErrors] = useState({});

    const validateForm = () => {
      let newErrors = {};
    
      if (!formData.firstName.trim()) {
        newErrors.firstName = " ";  
      }
      if (!formData.lastName.trim()) {
        newErrors.lastName = " ";  
      }
      if (!formData.dob.trim()) {
        newErrors.dob = " ";  
    } else {
        const selectedDate = new Date(formData.dob);
        const today = new Date();
        
        // Remove time part for accurate date comparison
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);
    
        if (selectedDate >= today) {  
            newErrors.dob = "Date of Birth must be in the past"; // Now today is also invalid
        }
    }
      if (!formData.mobile.trim()) {
        newErrors.mobile = " ";  
      }
      if (!formData.city.trim()) {
        newErrors.city = " ";  
      }
      if (!formData.district.trim()) {
        newErrors.district = " ";  
      }
      if (!formData.state.trim()) {
        newErrors.state = " ";  
      }
      if (!formData.pincode.trim()) {
        newErrors.pincode = " ";  
      }
      if (formData.panCardNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panCardNumber)) {
        newErrors.panCardNumber = "Enter a valid PAN Number (Eg: ABCDE1234F)";
      }
     
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
};
    

 // Handles radio button changes
 const handleRadioChange = (e) => {
    setFormData({ ...formData, identityProofType: e.target.value });
  };

  const handlePanChange = (e) => {
    setFormData({ ...formData, panCard: e.target.value, panCardNumber: e.target.value === "Yes" ? "" : formData.panCardNumber });
};
 


 

    const requestBody = {
        method: "post",  // Include this field
        ...formData,  // Spread form data
    };

   
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const navigate = useNavigate();

    const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
        "Dindigul" , "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
        "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
        "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathi",
        "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"
     ];
    const states = ["Tamil Nadu"];


    const handleChange = (e) => {
        
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

   
     
    const handleSubmit = async (e) => {
        console.log("OnSubmit Function");
        console.log(requestBody);

        e.preventDefault();
        if (!validateForm()) return; 
    
        try {
            // eslint-disable-next-line 
            const response = await fetch(
                "https://script.google.com/macros/s/AKfycbwar8XqOffGD-8_e1wIDuHIUUq1zuiqLfYKH00wrrTxhbdGNFgQVWNpRcvAqKpt1RxMYA/exec",
                {
                    method: "POST",
                    mode: "no-cors", // Prevents CORS issues
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
    
            console.log("Data sent successfully");
            setOpenSnackbar(true);
    
            // Clear the form after submission
            setFormData({
                firstName: "",
                lastName: "",
                dob: "",
                mobile: "",
                city: "",
                district: "",
                state: "",
                pincode: "",
                identityProofType: "", 
                identityProofNumber: "",
                panCard:"",
                panCardNumber:  "",
            });
    
            // Redirect after success
            setTimeout(() => {
                navigate("/login"); 
            }, 2000);
        } catch (error) {
            console.error("Error sending data:", error);
            alert("Failed to send data");
        }
    };

    const handleClear = () => {
        setFormData({
            firstName: "",
            lastName: "",
            dob: "",
            mobile: "",
            city: "",
            district: "",
            state: "",
            pincode: "",
            identityProofType: "", // Stores either 'Aadhar' or 'License'
            identityProofNumber: "",
            panCard:"",
            panCardNumber:  "",
        });
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px" }}>
      <Container>
        <Typography variant="h5" sx={{ fontWeight: "400", color: "#E52029", mb: 2, fontSize: "24px", textAlign: "center" }}>
          Fill the Details Below
        </Typography>
        <form onSubmit={handleSubmit} >
        <Grid item xs={12} md={6}>
          <Box
            component="form"
            sx={{
              backgroundColor: "#f8f9e9",
              padding: 4,
              borderRadius: "8px",
              borderColors: "#CEC35E",
              boxShadow: 3,
            }}
          > 
          
          
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
              <TextField
                fullWidth
                label="First Name"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                sx={{ mb: 2 }}
                error={!!errors.firstName}  
                helperText={errors.firstName || ""} 
                required
              />
              <TextField
                fullWidth
                label="Last Name"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                sx={{ mb: 2 }}
                error={!!errors.lastName}  
                helperText={errors.lastName || ""} 
                required
              />
              <TextField
                fullWidth
                label="Date of Birth"
                type="date"
                name="dob"
                InputLabelProps={{ shrink: true }}
                value={formData.dob}
                onChange={handleChange}
                error={!!errors.dob}  
                helperText={errors.dob || ""} 
                required
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Mobile Number"
                placeholder="Your Mobile Number"
                type="number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                sx={{ height: '56px' }}
                error={!!errors.mobile}  
                helperText={errors.mobile || " "} 
                required
                
              />
             
              <TextField
                fullWidth
                label="City"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                sx={{ mb: 2 }}
                error={!!errors.city}  
                helperText={errors.city || ""} 
                required
                
                
              />
               <FormControl fullWidth sx={{ mb: 2 }} required>
              <InputLabel shrink
              sx={{
                backgroundColor: "#f8f9e9",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >District</InputLabel>
              <Select 
              name="district" 
              value={formData.district} 
              onChange={handleChange}
              error={!!errors.district}  
                helperText={errors.district || ""} 
                required
              sx={{ textAlign: "left"}} >
              {districts.map((district, index) => (
               <MenuItem key={index} value={district}>
                {district}
                 </MenuItem>
                 ))}
               </Select>
              </FormControl>

              <FormControl fullWidth sx={{ mb: 2 }}  required>
               <InputLabel shrink
              sx={{
                backgroundColor: "#f8f9e9",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >State</InputLabel>
                  <Select name="state" value={formData.state} 
                  onChange={handleChange} 
                  error={!!errors.state}  
                helperText={errors.state|| ""} 
                required
                sx={{ textAlign: "left" }} >
                     {states.map((state, index) => (
                       <MenuItem key={index} value={state}>
                      {state}
                     </MenuItem>
                       ))}
                  </Select>
                   </FormControl>

              <TextField
                fullWidth
                label="Pincode"
                placeholder="Pincode"
                type="number"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                error={!!errors.pincode}  
                helperText={errors.pincode || ""} 
                required
                sx={{ mb: 2 }}
                inputProps={{ maxLength: 6, pattern: "[0-6]*" }}
                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6)}
              />
              <Box sx={{ backgroundColor: "#f8f9e9", p: 2 }}>
               <Grid container spacing={2} alignItems="center">
             {/* ID Proof Label & Radio Buttons in One Row */}
            <Grid item xs={2}>
            <FormLabel sx={{ whiteSpace: "nowrap" }} >ID Proof  </FormLabel>
             </Grid>
             <Grid item xs={12} sm={10}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            name="identityProofType"
            value={formData.identityProofType}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="aadhaar"
              control={<Radio sx={{ color: "gray" }} />}
              label="Aadhaar"
            />
            <FormControlLabel
              value="License"
              control={<Radio sx={{ color: "gray" }} />}
              label="License"
            />
            <FormControlLabel
              value="None"
              control={<Radio sx={{ color: "gray" }} />}
              label="None"
            />
          </RadioGroup>
        </FormControl>
             </Grid>

              {/* Aadhar Number Field */}
            {formData.identityProofType === "aadhaar" && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Aadhaar Number"
            type="number"
            name="identityProofNumber"
            value={formData.identityProofNumber}
            onChange={handleChange}
            error={
              formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
            }
            helperText={
              formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
                ? "Enter a valid Aadhaar Number (must be 12 digits)"
                : ""
            }
            inputProps={{ maxLength: 12 }}
            placeholder="Enter Aadhaar Number"
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/\D/g, "").slice(0, 12))
            }
           
         
             />
         
           </Grid>
              )}

                  {/* License Number Field */}
                {formData.identityProofType === "License" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="License Number"
                    type="text"
                    name="identityProofNumber"
                    value={formData.identityProofNumber}
                    onChange={handleChange}
                    error={
                      formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                    }
                    helperText={
                      formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                        ? "Enter a valid License Number (e.g., AB1234567890123)."
                        : ""
                    }
                    inputProps={{ maxLength: 15 }}
                    placeholder="Enter License Number"
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                    }
                    
                    
                  />
                
                </Grid>
               )}
               </Grid>
               </Box>
               {/* PAN Requirement Selection */}
               <Box sx={{ backgroundColor: "#f8f9e9", p:2 }}>
             <Grid container spacing={4} alignItems="center">
    
             {/* PAN Number Label */}
             <Grid item xs={2}>
             <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card</FormLabel>
                    </Grid>

                    {/* PAN Required Radio Buttons */}
                    <Grid item xs={12} sm={10}>
               <FormControl component="fieldset">
                <RadioGroup row name="panCard" value={formData.panCard} onChange={handlePanChange}>
                  <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio />} label="No" />
                  <FormControlLabel value="Later" control={<Radio />} label="Later" />
                </RadioGroup>
               </FormControl>
                    </Grid>
                </Grid>
            
                <Box sx={{ backgroundColor: "#f8f9e9", mt:2}}>
             {/* PAN Number Field (Only if "Yes" is selected) */}
             {formData.panCard === "Yes" && (
            
            
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="PAN Number"
                  placeholder="Enter PAN Number"
                  name="panCardNumber"
                  value={formData.panCardNumber}
                  onChange={handleChange}
                  error={!!errors.panCardNumber}  
                  helperText={errors.panCardNumber || ""}
                  inputProps={{ maxLength: 10 }}
                  onInput={(e) =>(e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))
                  
                  }
                  
                />
              </Grid>
            
             )}
            </Box>
            </Box>
                
            </div>
          </Box>
              
          {/* Buttons */}
    <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
    <Grid item>
        <Button type="submit" 
        onSubmit={handleSubmit}
        variant="contained" 
        fullWidth style={{ backgroundColor: "green", color: "white" }}>
            Register
        </Button>
    </Grid>
    <Grid item >
        <Button variant="contained" fullWidth style={{ backgroundColor: "#6C757D", color: "white" }} onClick={handleClear}>
            Clear
        </Button>
    </Grid>
    <Grid item>
        <Button variant="contained" fullWidth style={{ backgroundColor: "#E52029", color: "white" }} onClick={() => navigate("/")}>
            Cancel
        </Button>
        </Grid>
        </Grid>
        </Grid>
        </form>
      </Container>

      {/* Snackbar Alert */}
      <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
      <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
         Member Created Successfully!
       </Alert>
       </Snackbar>
       
    </Box>
   
  );
}

export default Register;